<template>
    <div id="finance-detail">
        <h6 class="success bold">FINANCIAMIENTO SOLICITADO</h6>
        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-list>
                    <vs-list-item title="Costo total">{{ costFormat(finance.total_cost_requested) }}</vs-list-item>
                    <vs-list-item title="Plazo">{{ (finance.term_requested != null ? `${finance.term_requested} meses` : '--') }}</vs-list-item>
                    <vs-list-item title="Enganche">{{ finance.deposit_request != null ? `${(finance.deposit_request*100).toFixed(2) }%` : "--" }}</vs-list-item>
                    <!-- <vs-list-item title="Uso del crédito">{{ finance.loan_use_reason||"--" }}</vs-list-item>
                    <vs-list-item title="Mejora del negocio">{{ source.improve_business_reason||"--" }}</vs-list-item>
                    <vs-list-item title="Mejora ESG">{{ source.improve_esg_reason||"--" }}</vs-list-item> -->
                </vs-list>
                <p class="p-text">
                    <span class="bold title-item">Uso del crédito</span> </br>
                    {{ finance.loan_use_reason||"--" }}
                </p>
                <p class="p-text">
                    <span class="bold title-item">Mejora del negocio</span> </br>
                    {{ source.improve_business_reason||"--" }}
                </p>
                <p class="p-text">
                    <span class="bold title-item">Mejora ESG</span> </br>
                    {{ source.improve_esg_reason||"--" }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import formatHelper from "@mixins/formatHelper.js"
export default {
    name: "FinanceDetail",
    mixins: [formatHelper],
    props: {
        source: Object
    },
    data: () => ({
    }),
    computed: {
        finance() {
            return this.source.finance;
        }
    }
}
</script>

<style>

.p-text {
    line-height: 15px;
    font-size: 14px;
    margin-left: 9px;
    margin-right: auto;
}

.title-item {
    font-size: 14px;
    color: #4f5356;
    font-weight: 700;
    /* margin-left: 9px; */
}

</style>